export const HIVE_FRONTENDS = [
  { id: 'hive', name: 'Hive Blog', domain: 'hive.blog', getUrl: (author, permlink) => `https://hive.blog/@${author}/${permlink}` },
  { id: 'peakd', name: 'PeakD', domain: 'peakd.com', getUrl: (author, permlink) => `https://peakd.com/@${author}/${permlink}` },
  { id: 'inleo', name: 'InLeo', domain: 'inleo.io', getUrl: (author, permlink) => `https://inleo.io/@${author}/${permlink}` },
  { id: 'ecency', name: 'Ecency', domain: 'ecency.com', getUrl: (author, permlink) => `https://ecency.com/@${author}/${permlink}` },
  { id: 'slothbuzz', name: 'SlothBuzz', domain: 'slothbuzz.com', getUrl: (author, permlink) => `https://slothbuzz.com/@${author}/${permlink}` },
  { id: 'scrobble', name: 'Scrobble', domain: 'scrobble.life', getUrl: (author, permlink) => `https://scrobble.life/@${author}/${permlink}` },
  { id: 'hivesuite', name: 'HiveSuite', domain: 'hivesuite.app', getUrl: (author, permlink) => `https://hivesuite.app/@${author}/${permlink}` }
];

export const getHiveFrontendPattern = () => {
  const domains = HIVE_FRONTENDS.map(f => f.domain.replace(/\./g, '\\.')).join('|');
  return new RegExp(`https?:\\/\\/(?:${domains})\\/(?:[^/]+\\/)*@?([a-zA-Z0-9.-]+)\\/([a-zA-Z0-9-]+)`);
};
